import { useProjectDetailPage } from "../store";
import { Typography, Box, Card, CardContent, Chip, Divider } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledCard = styled(Card)(({ theme }) => ({
  borderLeft: `4px solid ${theme.palette.primary.main}`,
  borderRadius: 8,
  transition: "all .25s ease",
  boxShadow: theme.shadows[1],
  marginBottom: theme.spacing(3),
  overflow: "hidden",
}));

export const CardSummary = () => {
  const { project } = useProjectDetailPage();

  const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("es-MX") : "—");
  const fmtMoney = (v, currency = "MXN") =>
    new Intl.NumberFormat("es-MX", { style: "currency", currency }).format(Number(v || 0));

  return (
    <StyledCard elevation={1}>
      <Box
        sx={(t) => ({
          bgcolor: "primary.main",
          color: "primary.contrastText",
          py: 1.5,
          px: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          "& .title": { fontWeight: 700, color: "inherit" },
          "& .sub": { color: t.palette.primary.contrastText, opacity: 0.85 },
        })}
      >
        <Box>
          <Typography className="title" variant="h6">
            {project.name || "Proyecto"}
          </Typography>
          <Typography className="sub" variant="body2">
            Estado: {project.status || "N/D"}
          </Typography>
        </Box>
      </Box>

      <CardContent>
        <Typography variant="body2" color="primary.main">
          {project.description || "Sin descripción"}
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 2 }}>
          <Chip label={`Moneda: ${project.currency || "MXN"}`} />
          <Chip label={`Dev estimado: ${fmtMoney(project.estimatedDevCost, project.currency)}`} />
          <Chip label={`Tiempo estimado: ${project.estimatedTimeDays ?? 0} días`} />
          <Chip label={`Inicio disponible: ${fmtDate(project.availableStartDate)}`} />
          {project.selectedPaymentDays ? <Chip label={`Pago cada ${project.selectedPaymentDays} días`} /> : null}
          {project.initPercentApplied != null ? <Chip label={`Anticipo: ${project.initPercentApplied}%`} /> : null}
          <Chip label={`Creado: ${fmtDate(project.created_at || project.createdAt)}`} />
          {project.updated_at || project.updatedAt ? <Chip label={`Actualizado: ${fmtDate(project.updated_at || project.updatedAt)}`} /> : null}
        </Box>
      </CardContent>
    </StyledCard>
  );
}